import {useEffect, useState} from "react";
import {getDiseaseSearch, getDiseaseStats} from "../Utils/api";
import {useParams} from "react-router-dom";
import {Button, Col, Row} from "antd";
import {SearchResultList} from "./SearchResultList";
import {PositivityList} from "./PositivityList";
import {SearchResultsHeader} from "./SearchResultsHeader";
import {DiseaseDetailList} from "./DiseaseDetailList";
import {GeneList} from "./GeneList";
import {RNAList} from "./miRNAList";
import {CloudDownloadOutlined} from "@ant-design/icons";
import qs from "qs"
import {baseUrl} from "../Utils/config";

export const DiseaseDetails = () => {

  const [isLoading, setIsLoading] = useState(false)
  const [isStatsLoading, setIsStatsLoading] = useState(false)
  const [listSwitcher, setListSwitcher] = useState("drugs")
  const [filters, setFilters] = useState({})
  const [data, setData] = useState({
    drugs: {
      data: []
    },
    genes: {
      data: []
    },
    miRNAs: {
      data: []
    },
    lncRNAs: {
      data: []
    },
    alternateMedicines: {
      data: []
    }
  })
  const [stats, setStats] = useState({
    stats: [],
    count: []
  })

  const switchValue = listSwitcher => {
    if (listSwitcher === 'drugs') {
      return (
        <DiseaseDetailList fetchData={fetchData} data={data.drugs} isLoading={isLoading}/>
      )
    } else if (listSwitcher === 'genes') {
      return(
        <GeneList fetchData={fetchData} data={data.genes} isLoading={isLoading} />
      )
    } else if (listSwitcher === 'miRNAs') {
      return(
        <RNAList fetchData={fetchData} data={data.miRNAs} isLoading={isLoading} />
      )
    } else if (listSwitcher === 'alternateMedicines') {
      return(
        <DiseaseDetailList fetchData={fetchData} data={data.alternateMedicines} isLoading={isLoading} entityType="alternateMedicine" />
      )
    } else {
      return(
        <RNAList fetchData={fetchData} data={data.lncRNAs} isLoading={isLoading} entityType="lncRNAs" />
      )
    }
  }

  const params = useParams()

  useEffect(() => {
    setIsStatsLoading(true)
    getDiseaseStats({
      term: params.disease
    })
      .then(r => setStats(r.data))
      .then(_ => setIsStatsLoading(false))
      .catch(e => console.log(e))
  }, [params.disease])

  const fetchData = (filters = {}) => {
    setIsLoading(true)
    setFilters({ filter: filters.filter, sorter: filters.sorter })
    getDiseaseSearch({
      term: params.disease,
      type: listSwitcher,
      ...filters
    })
      .then(r => {
        setData({ ...data, [listSwitcher]: r.data })
        setIsLoading(false)
      })
      .catch(e => console.log(e))
  }

  useEffect(() => {
    fetchData()
  }, [listSwitcher, params.disease])

  const button = (
    <Button target="_blank" href={`${baseUrl}/export?term=${params.disease}&type=${listSwitcher}${filters ? `&${qs.stringify(filters)}` : ''}`} disabled={isLoading} size="large" type="primary" icon={<CloudDownloadOutlined />}>Download</Button>
  )

  return(
    <Row gutter={[20, 20]}>
      <Col lg={6} xs={24}>
        <SearchResultList count={stats.count} data={data} isLoading={isStatsLoading} listSwitcher={listSwitcher} setListSwitcher={setListSwitcher} />
        <br />
        <PositivityList data={stats.stats} isLoading={isStatsLoading} />
      </Col>
      <Col lg={18} xs={24}>
        <SearchResultsHeader button={button} title={params.disease} />
        <br />
        {switchValue(listSwitcher)}
      </Col>
    </Row>
  )
}